<template>
  <div v-if="showLoading">
    <div class="spinner"></div>
  </div>
</template>

<script>
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      showLoading: false,
      showTransition: false,
    };
  },
  watch: {
    'loadingSpinnerStore.loadingSpinner': function () {
      const self = this;
      if (self.loadingSpinnerStore.loadingSpinner) {
        self.showLoading = true;
        self.showTransition = true;
      } else {
        self.showTransition = false;
        setTimeout(() => {
          self.showLoading = false;
        }, 200);
      }
    },
  },
};
</script>
<style>
.spinner {
  height: 22px;
  width: 22px;
  animation: rotateSpinner 0.8s infinite linear;
  border: 2px solid black;
  border-right-color: transparent;
  border-radius: 50%;
}

@keyframes rotateSpinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
